var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icona_ora",
    "data-name": "icona ora",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.14,
    height: 11.14,
    viewBox: "0 0 11.14 11.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_94",
    "data-name": "Raggruppa 94",
    transform: "translate(5.139 2.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_93",
    "data-name": "Raggruppa 93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36",
    "data-name": "Tracciato 36",
    d: "M238.585,122.748l-1.553-1.165V119.21a.431.431,0,0,0-.863,0V121.8a.431.431,0,0,0,.173.345l1.726,1.294a.431.431,0,0,0,.518-.69Z",
    transform: "translate(-236.169 -118.779)",
    fill: "currentColor"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_96",
    "data-name": "Raggruppa 96"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_95",
    "data-name": "Raggruppa 95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37",
    "data-name": "Tracciato 37",
    d: "M5.57,0a5.57,5.57,0,1,0,5.57,5.57A5.576,5.576,0,0,0,5.57,0Zm0,10.277A4.707,4.707,0,1,1,10.277,5.57,4.713,4.713,0,0,1,5.57,10.277Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.026513f9b4df1b046cd5ba80b9e9a368.svg";
export { ForwardRef as ReactComponent };